<div class="row">
    <div class="col-lg-6 col-md-12">
        <label class="label-data">Iniciado:</label>
        <formulario-dinamico
            *ngIf="colunasIniciadoEntre"
            [colunas]="colunasIniciadoEntre"
            [(entidade)]="valorFiltro.filtroIniciado"
            (entidadeChange)="changeFormulario()"
        ></formulario-dinamico>
    </div>
    <div class="col-lg-6 col-md-12">
        <label class="label-data">Concluido:</label>
        <formulario-dinamico
            *ngIf="colunasConcluidoEntre"
            [colunas]="colunasConcluidoEntre"
            [(entidade)]="valorFiltro.filtroConcluido"
            (entidadeChange)="changeFormulario()"
        ></formulario-dinamico>
    </div>
    <div class="col-sm-6" *ngIf="tipoAcesso == TIPO_ACESSO_ADM">
        <formulario-dinamico 
            [colunas]="colunasClientes" 
            [(entidade)]="valorFiltro.filtroCliente"
            (entidadeChange)="changeCliente($event.cliente)"
        ></formulario-dinamico>
    </div>
    <div class="col-sm-6">
        <formulario-dinamico
            *ngIf="colunasEquipes"
            [colunas]="colunasEquipes" 
            [(entidade)]="valorFiltro.filtroEquipe"
            (entidadeChange)="changeFormulario()"
        ></formulario-dinamico>
    </div>
</div>




